import { memo } from 'react';
const SvgLink2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="link-2_svg__feather link-2_svg__feather-link-2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3M8 12h8" />
  </svg>
);
const Memo = memo(SvgLink2);
export default Memo;
